<ul>
    <li>
        <a routerLink="/app" (click)="start()" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            class="home-icon">{{ 'stt.menu.start' | translate }}</a>
    </li>
    <li>
        <a routerLink="links" routerLinkActive="active">{{ 'stt.menu.Links' | translate }}</a>
    </li>
    <mat-select class="link">
        <mat-option value="1" (click)="redirectWamp()">{{ 'stt.menu.WAMP' | translate }}</mat-option>
        <mat-option value="2" (click)="redirectCalendar()">{{ 'stt.menu.calendar' | translate }}</mat-option>
    </mat-select>
    <li><a class="faq" routerLink="faq" routerLinkActive="active">{{ 'stt.menu.questions' | translate }}</a></li>
    <li><a routerLink="help" *ngIf="username === 'stb'" routerLinkActive="active">{{ 'stt.menu.help' | translate }}</a></li>
</ul> 